import { useMatches } from 'react-router';

import type { Optional } from '@shared/types/utils';

export type RouteData = {
  pageData: {
    jsonLDTag: string;
  };
};

export function DynamicScripts() {
  const matches = useMatches();

  const routeData = matches.find((match) => {
    const data = match.data as RouteData;
    return data?.pageData?.jsonLDTag;
  })?.data as Optional<RouteData>;

  const pageData = routeData?.pageData;

  if (!pageData) return null;

  return (
    <>
      {pageData.jsonLDTag && (
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: pageData.jsonLDTag,
          }}
        />
      )}
    </>
  );
}
